import axios from 'axios'

import { CMS_ADAPTER_URL } from '../constants/url'

import { getPinflagApiKey } from './utils'
import { CMS_ADAPTER_TIMEOUT } from '../constants/pinflag'

const cmsInstance = axios.create({
  baseURL: CMS_ADAPTER_URL,
  headers: { 'x-api-key': process.env.REACT_APP_CMS_KEY }
})

const INTERCEPTED_URLS = [
  '/abandoned-cart',
  '/shopify/cart/mark-as-paid',
  '/order/mark-as-paid'
]

cmsInstance.interceptors.request.use((config) => {
  const newConfig = config

  if (INTERCEPTED_URLS.includes(config.url)) {
    const pinflagApiKey = getPinflagApiKey()

    newConfig.headers['x-api-key'] = pinflagApiKey
    newConfig.timeout = CMS_ADAPTER_TIMEOUT
  }

  return newConfig
})

export default cmsInstance
